import React, { useState } from 'react';
import { normalizeWhatsAppNumber, buildWaMeLink, fillTemplate } from '../../lib/whatsapp';

export const daysRemaining = (endDate) => {
  if (!endDate) return null;
  const end = new Date(`${String(endDate).slice(0, 10)}T00:00:00Z`);
  const today = new Date(`${new Date().toISOString().slice(0, 10)}T00:00:00Z`);
  return Math.round((end - today) / 86400000);
};

export const daysBarColor = (dl) => {
  if (dl === null) return 'bg-slate-300';
  if (dl < 0) return 'bg-red-500';
  if (dl <= 7) return 'bg-red-500';
  if (dl <= 14) return 'bg-amber-500';
  return 'bg-teal-500';
};

export const DaysBar = ({ endDate, testId }) => {
  const dl = daysRemaining(endDate);
  if (dl === null) return <span className="text-xs text-slate-400" data-testid={testId}>—</span>;
  const pct = dl < 0 ? 0 : Math.max(6, Math.min(100, (dl / 30) * 100));
  const label = dl < 0 ? `منتهي منذ ${Math.abs(dl)} يوم` : `${dl} يوم متبقي`;
  return (
    <div className="w-32" data-testid={testId} title={label}>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
        <div className={`h-full rounded-full ${daysBarColor(dl)}`} style={{ width: `${pct}%` }} />
      </div>
      <div className={`mt-1 text-[11px] font-semibold ${dl < 0 ? 'text-red-600' : dl <= 7 ? 'text-red-600' : dl <= 14 ? 'text-amber-600' : 'text-slate-500'}`}>{label}</div>
    </div>
  );
};

// ====================== قوالب رسائل واتساب (Super Admin) ======================
// p = مخاطبة الجمع (منشأة) / الإفراد (مدرب) — نفس القوالب بصياغة مناسبة لكل حالة
const buildTemplates = (p) => {
  const s = p ? 'كم' : 'ك';           // اشتراك + كم/ك
  const tellUs = p ? 'أخبرونا' : 'أخبرنا';
  const youAre = p ? 'أنتم' : 'أنت';
  const owner = p ? 'منشأت' : 'حساب';
  const sign = '\n\nفريق تسيار 💙';
  return [
    {
      key: 'reminder', group: 'الاشتراك', label: 'تذكير بالدفع',
      body: `مرحباً {{entity_name}} 👋\n\nنود تذكير${s} بأن اشتراك${s} في منصة تسيار يقترب من موعد الاستحقاق.\n\n• الباقة: {{plan_name}}\n• تاريخ الانتهاء: {{expiry_date}}\n• المتبقي: {{days_remaining}} يوم\n• المبلغ المستحق: {{amount}} ريال\n\nلإتمام التجديد أو لأي استفسار، نحن مع${s} على هذه المحادثة مباشرة.${sign}`,
    },
    {
      key: 'expiring_soon', group: 'الاشتراك', label: 'اقتراب الانتهاء',
      body: `مرحباً {{entity_name}} 👋\n\nتنبيه ودّي: اشتراك${s} في منصة تسيار (باقة {{plan_name}}) ينتهي بعد {{days_remaining}} يوم — بتاريخ {{expiry_date}}.\n\nالتجديد يحفظ جميع البيانات والتقارير ويضمن استمرار العمل دون انقطاع.\n\n${tellUs} إن رغب${p ? 'تم' : 'ت'} في التجديد وسنتولى الباقي.${sign}`,
    },
    {
      key: 'ended', group: 'الاشتراك', label: 'انتهاء الاشتراك',
      body: `مرحباً {{entity_name}} 👋\n\nنعلم${s} بأن اشتراك${s} في منصة تسيار (باقة {{plan_name}}) قد انتهى بتاريخ {{expiry_date}}.\n\n• البيانات محفوظة بالكامل ولم يُفقد شيء\n• يمكن استعادة الوصول فوراً بعد التجديد\n\nنحن في انتظار${s} في أي وقت 🙏${sign}`,
    },
    {
      key: 'payment_received', group: 'الاشتراك', label: 'تأكيد التجديد',
      body: `شكراً ل${s} {{entity_name}} ✅\n\nتم استلام مبلغ التجديد وتفعيل الاشتراك بنجاح.\n\n• الباقة: {{plan_name}}\n• سارية حتى: {{expiry_date}}\n• المبلغ: {{amount}} ريال\n\nنتمنى ل${s} موسماً موفقاً، ونحن مع${s} في أي وقت.${sign}`,
    },
    {
      key: 'upgrade', group: 'الاشتراك', label: 'ترقية الباقة',
      body: `مرحباً {{entity_name}} 👋\n\nالباقة الحالية: {{plan_name}}\n\nلاحظنا أن استخدام${s} في نمو مستمر — والترقية تتيح:\n\n• حدوداً أوسع للاعبين والمستخدمين\n• تقارير ومزايا إضافية\n• أولوية في الدعم الفني\n\nنسعد بإرسال عرض سعر مخصص إن رغب${p ? 'تم' : 'ت'} بذلك.${sign}`,
    },
    {
      key: 'welcome', group: 'الدعم والمتابعة', label: 'ترحيب وتهيئة',
      body: `أهلاً وسهلاً {{entity_name}} 🎉\n\nيسعدنا انضمام${s} إلى منصة تسيار!\n\nالحساب جاهز الآن، وهذه أفضل ثلاث خطوات للبداية:\n\n1. إضافة الفئات والفرق\n2. تسجيل اللاعبين واشتراكاتهم\n3. بدء تسجيل الحضور والتدريبات\n\nوإن رغب${p ? 'تم' : 'ت'}، نرتب جلسة تعريفية سريعة ${p ? 'لفريقكم' : 'لك'}.${sign}`,
    },
    {
      key: 'support_checkin', group: 'الدعم والمتابعة', label: 'هل تحتاج دعم؟',
      body: `مرحباً {{entity_name}} 👋\n\nنتابع مع${s} فقط للاطمئنان 🙏\n\n• هل يسير كل شيء بشكل جيد في تسيار؟\n• هل هناك ميزة لم تتضح بعد؟\n• هل تحتاج${p ? 'ون' : ''} مساعدة في أي خطوة؟\n\nاكتبوا لنا هنا، وسنساعد${p ? 'كم' : 'ك'} خطوة بخطوة — الدعم جزء من الاشتراك ولا يكلف شيئاً.${sign}`,
    },
    {
      key: 'inactive', group: 'الدعم والمتابعة', label: 'متابعة انقطاع',
      body: `مرحباً {{entity_name}} 👋\n\nلاحظنا أن الحركة على ${owner}${p ? 'كم' : 'ك'} أقل من المعتاد، ونود الاطمئنان.\n\nإن كان السبب صعوبة في أي خطوة فنحن جاهزون فوراً:\n\n• إدخال اللاعبين عبر ملف Excel جاهز\n• ضبط الباقات والاشتراكات\n• شرح سريع للحضور والتقارير\n\n${tellUs} بما تحتاج${p ? 'ونه' : 'ه'} وسنتولى الباقي.${sign}`,
    },
    {
      key: 'training_session', group: 'الدعم والمتابعة', label: 'جلسة تدريبية',
      body: `مرحباً {{entity_name}} 👋\n\nنوفّر جلسة تدريبية مجانية عبر الاتصال المرئي (20–30 دقيقة) لشرح النظام بشكل عملي.\n\nتشمل الجلسة:\n• إدارة اللاعبين والفئات\n• الاشتراكات والمالية\n• الحضور والتقارير\n\n${tellUs} بالوقت المناسب وسنرتب الموعد ✅${sign}`,
    },
    {
      key: 'new_features', group: 'الدعم والمتابعة', label: 'ميزات جديدة',
      body: `تحديث جديد في تسيار 🚀\n\nمرحباً {{entity_name}}، أضفنا تحسينات نعتقد أنها ستفيد${p ? 'كم' : 'ك'}:\n\n• تقارير رياضية أعمق مع طباعة احترافية\n• استديو التمارين: رسم الخطط وتحريكها\n• إدارة المواسم والاشتراكات بمرونة أكبر\n\nكل ذلك متاح الآن في الحساب بلا أي خطوة إضافية.\n\nوإن احتج${p ? 'تم' : 'ت'} شرحاً سريعاً لأي ميزة، ${youAre} على بُعد رسالة.${sign}`,
    },
    {
      key: 'feedback', group: 'الدعم والمتابعة', label: 'طلب رأي',
      body: `مرحباً {{entity_name}} 👋\n\nرأي${s} يهمنا كثيراً 🙏\n\n• ما أكثر ما أعجب${p ? 'كم' : 'ك'} في تسيار؟\n• وما الشيء الذي تتمن${p ? 'ون' : 'ى'} تطويره؟\n\nملاحظة واحدة من${s} قد تصبح ميزة في التحديث القادم.\n\nشكراً لثقة${s} 💙`,
    },
  ];
};

const WHATSAPP_TEMPLATES = {
  club_subscription: buildTemplates(true),
  coach_subscription: buildTemplates(false),
};

export const AdminWhatsAppModal = ({ open, onClose, type, entity }) => {
  const templates = WHATSAPP_TEMPLATES[type] || [];
  const [templateKey, setTemplateKey] = useState(templates[0]?.key || '');
  const [text, setText] = useState('');
  const [phone, setPhone] = useState(entity?.phone || '');

  React.useEffect(() => {
    if (!open) return;
    setPhone(entity?.phone || '');
    const dl = daysRemaining(entity?.expiry_date);
    const vars = {
      entity_name: entity?.name || '',
      plan_name: entity?.plan_name || '',
      expiry_date: entity?.expiry_date ? String(entity.expiry_date).slice(0, 10) : 'غير محدد',
      days_remaining: dl !== null ? Math.max(0, dl) : '—',
      amount: entity?.amount != null ? entity.amount : 'غير محدد',
    };
    const tpl = templates.find((t) => t.key === templateKey) || templates[0];
    setTemplateKey(tpl?.key || '');
    setText(tpl ? fillTemplate(tpl.body, vars) : '');
    // eslint-disable-next-line
  }, [open, entity, type]);

  const onPickTemplate = (key) => {
    setTemplateKey(key);
    const dl = daysRemaining(entity?.expiry_date);
    const vars = {
      entity_name: entity?.name || '',
      plan_name: entity?.plan_name || '',
      expiry_date: entity?.expiry_date ? String(entity.expiry_date).slice(0, 10) : 'غير محدد',
      days_remaining: dl !== null ? Math.max(0, dl) : '—',
      amount: entity?.amount != null ? entity.amount : 'غير محدد',
    };
    const tpl = templates.find((t) => t.key === key);
    setText(tpl ? fillTemplate(tpl.body, vars) : '');
  };

  const send = () => {
    const normalized = normalizeWhatsAppNumber(phone);
    if (!normalized) return;
    window.open(buildWaMeLink(normalized, text), '_blank');
  };

  if (!open) return null;

  const normalized = normalizeWhatsAppNumber(phone);
  const groups = [...new Set(templates.map((t) => t.group || ''))];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm" data-testid="admin-whatsapp-modal">
      <div className="max-h-[92vh] w-full max-w-3xl overflow-y-auto rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-slate-100 bg-gradient-to-l from-emerald-50 to-white px-5 py-4">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-600 text-white">
              <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5"><path d="M17.5 14.4c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.1-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.4.5-.6.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5 0-.1-.7-1.7-.9-2.3-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4 0 1.4 1 2.8 1.2 3 .1.2 1.9 3 4.7 4.1 2.3 1 2.8.8 3.3.8.5 0 1.7-.7 1.9-1.3.2-.7.2-1.2.2-1.3-.1-.2-.2-.2-.5-.3zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.4 1.3 4.9L2 22l5.2-1.3c1.4.8 3.1 1.3 4.8 1.3 5.5 0 10-4.5 10-10S17.5 2 12 2z" /></svg>
            </span>
            <div>
              <h3 className="text-base font-bold text-slate-900">رسالة واتساب</h3>
              <p className="text-xs text-slate-500">{entity?.name}</p>
            </div>
          </div>
          <button onClick={onClose} className="rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600" data-testid="admin-whatsapp-close">✕</button>
        </div>

        <div className="grid gap-5 p-5 md:grid-cols-[1.15fr_1fr]">
          <div className="space-y-4">
            <div>
              <label className="mb-1.5 block text-xs font-bold text-slate-600">رقم الجوال</label>
              <input dir="ltr" value={phone} onChange={(e) => setPhone(e.target.value)} className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm outline-none transition-colors focus:border-emerald-500" data-testid="admin-whatsapp-phone" placeholder="05xxxxxxxx" />
            </div>
            <div className="space-y-2.5">
              <label className="block text-xs font-bold text-slate-600">القالب ({templates.length} جاهزة)</label>
              {groups.map((g) => (
                <div key={g}>
                  {g && <div className="mb-1.5 text-[11px] font-bold uppercase tracking-wide text-slate-400">{g}</div>}
                  <div className="flex flex-wrap gap-1.5">
                    {templates.filter((t) => (t.group || '') === g).map((t) => (
                      <button key={t.key} type="button" onClick={() => onPickTemplate(t.key)} data-testid={`admin-whatsapp-template-${t.key}`}
                        className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-all active:scale-95 ${templateKey === t.key ? 'bg-emerald-600 text-white shadow-sm shadow-emerald-200' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>
                        {t.label}
                      </button>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div>
              <label className="mb-1.5 block text-xs font-bold text-slate-600">نص الرسالة (قابل للتعديل)</label>
              <textarea rows={11} value={text} onChange={(e) => setText(e.target.value)} className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm leading-relaxed outline-none transition-colors focus:border-emerald-500" data-testid="admin-whatsapp-text" />
              <div className="mt-1 text-[11px] text-slate-400">{text.length} حرف — الأسطر الفارغة تُرسل كما هي في واتساب</div>
            </div>
          </div>

          <div className="flex flex-col">
            <label className="mb-1.5 block text-xs font-bold text-slate-600">معاينة المحادثة</label>
            <div className="flex-1 rounded-xl border border-slate-200 bg-[#e5ddd4] p-3" data-testid="admin-whatsapp-preview">
              <div className="ms-auto max-w-[92%] rounded-xl rounded-tl-sm bg-[#d9fdd3] px-3 py-2 shadow-sm">
                <p className="whitespace-pre-wrap break-words text-[13px] leading-[1.75] text-slate-800">{text || 'اختر قالباً للمعاينة…'}</p>
                <div className="mt-1 text-end text-[10px] text-slate-500">
                  {new Date().toLocaleTimeString('ar-SA', { hour: '2-digit', minute: '2-digit' })} ✓✓
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between gap-2 border-t border-slate-100 bg-slate-50/70 px-5 py-3.5">
          <span className="text-[11px] text-slate-400">تُفتح المحادثة في واتساب لمراجعتها قبل الإرسال</span>
          <div className="flex gap-2">
            <button onClick={onClose} className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-600 transition-colors hover:bg-slate-100">إلغاء</button>
            <button onClick={send} disabled={!normalized} data-testid="admin-whatsapp-send" className="rounded-xl bg-emerald-600 px-5 py-2 text-sm font-bold text-white shadow-sm transition-all hover:bg-emerald-700 active:scale-95 disabled:opacity-40">
              فتح واتساب وإرسال
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
